import { createSlice, Dispatch } from '@reduxjs/toolkit';
import { IProductSlice } from '../../../types/storeTypes';
import CONFIG from '../../../config';
import { getGeoResourcesSettings, pollConstants } from '../../../utils/Functions';
import { UBISOFT_PLUS_SUBSCRIPTION_ID } from '../../../constants/constants';
import axios from 'axios';
import { IProduct } from '../../../types';

const product = createSlice({
  name: 'product',
  initialState: {
    fetching: true,
    fetchingError: false,
    subscriptionProduct : undefined,
    geoRessources : {}
  } as IProductSlice,
  reducers: {
    setSubscriptionProduct(state, action) {
      state.fetching = false;
      state.subscriptionProduct = action.payload;
    },
    setGeoRessources(state,action){
      state.geoRessources = action.payload
    },
    setSubscriptionFetchError(state) {
      state.fetching = false;
      state.fetchingError = true;
    }
  }
});

const { setSubscriptionProduct, setSubscriptionFetchError,setGeoRessources } = product.actions;

export default product.reducer;

export function fetchProduct(){
  return async function(dispatch: Dispatch) {
    const Constants = await pollConstants();
    const geoResourcesSettings = await getGeoResourcesSettings();
    dispatch(setGeoRessources(geoResourcesSettings));

    const { SITE_ID } = Constants;
    const productEndpoint = `https://${
      CONFIG.apiHost
    }/s/${SITE_ID}/dw/shop/v20_4/products/(${UBISOFT_PLUS_SUBSCRIPTION_ID})?expand=prices,variations&currency=${geoResourcesSettings.currency.toUpperCase()}&client_id=${
      CONFIG.clientId
    }`;

    if (window.location.host !== 'store.ubi.com') {
      console.log('productEndpoint: ', productEndpoint);
    }

    const response = await axios(productEndpoint);

    if (response.status !== 200) {
      dispatch(setSubscriptionFetchError())
    }
    else{
      const products: IProduct[] = response.data.data.map((product: any) => {
        const data: IProduct = {
          id: product.id,
          name: product.name,
          regularPrice: parseFloat(JSON.parse(product.c_display_price).regular),
          promoPrice: parseFloat(JSON.parse(product.c_display_price).promo_price),
          discountPercentage: parseFloat(JSON.parse(product.c_display_price).percent_off)
        };
        return data;
      });

      dispatch(setSubscriptionProduct(products[0]));
    }
  }
}